import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as Cookies from 'js-cookie';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import PhoneInputService from 'src/app/lib/phone-input/phone-input.service';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PeopleService } from 'src/app/services/people/people.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import { OrganisationService } from "src/app/services/organisation/organisation.service";
import { PeopleProfileHelpModalComponent } from '../people-profile-help-modal/people-profile-help-modal.component';
import { SelectCheckTypeModalComponent } from '../select-check-type-modal/select-check-type-modal.component';
import { SelectRequestModalComponent } from '../select-request-modal/select-request-modal.component';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-people-profile-header',
  templateUrl: './people-profile-header.component.pug',
  styleUrls: ['./people-profile-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PeopleProfileHeaderComponent implements OnInit {

  @Input() details: any;
  @Input() profile: any;
  moment: any;
  startDate: any;
  bsModalRef: any;
  noPermissionToSend: any;
  selectedTab: string | null = $localize`People`;
  peopleProfileHelpModal: BsModalRef = new BsModalRef();
  selectCheckTypeModal: BsModalRef = new BsModalRef();
  org_uid = Cookies.get(ConstantsService.ORG_COOKIE);
  previousUrl = '/';
  showSendRequestButton = false
  canViewContactAccountManagerLink = false
  requestTemplate = false;

  constructor(private modalService: BsModalService,
    private peopleService: PeopleService,
    private planservice: PlanService,
    private permissions: PermissionsService,
    public organisation: OrganisationService,
    private router: Router) { }

  ngOnInit(): void {
    this.showSendRequestButton = this.permissions.hasPermission('can_view_send_request_button')
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    this.canViewContactAccountManagerLink = this.permissions.hasPermission(
      'can_access_subscription_contact_account_manager_link')

    this.selectedTab = $localize`Back`;
    this.previousUrl = localStorage.getItem('previousUrl') ?? '/'
    if (localStorage.getItem('people-page-selected-tab') === 'talent_pool') {
      this.selectedTab = $localize`Talent pool`;
    }

    this.startDate = moment(this.details.created, 'YYYY-MM-DD');
    this.startDate = this.startDate.format('ll');
  }
  showHelp() {
    this.peopleProfileHelpModal = this.modalService.show(PeopleProfileHelpModalComponent, {
      class: 'modal-dialog-centered help-modal'
    });
  }

  sendSurveymethod() {
    let phone: any = {};
    let person_email_list: any = []

    if (this.details.emails_with_types) {
      if (this.details.emails_with_types.work) {
        person_email_list.push([this.details.emails_with_types.work, 0])
      }
      if (this.details.emails_with_types.personal) {
        person_email_list.push([this.details.emails_with_types.personal, 1])
      }
    }
    let selectedEmail = this.details.emails_with_types?.personal || this.details.emails_with_types?.work || this.details.email;

    let selectedPerson = {
      'first_name': this.details.first_name,
      'last_name': this.details.last_name,
      'email': selectedEmail,
      'person_email_list': person_email_list,
      'department': this.profile.department
    };
    if (this.details.mobile) {
      phone = PhoneInputService.setCountryCode(this.details.mobile);
      selectedPerson['mobile_phone'] = phone.phoneNumber;
      selectedPerson['country_code'] = phone.callingCode;
    }
    this.peopleService.selectedPeople = [selectedPerson];
    this.openSelectReferenceModal()
  }

  sendSurvey() {
    const state = this.planservice.getPlanState()
    const valid_start_time = state.valid_from
    const current_time = state.current_time
    const valid_end_time = state.valid_till

    if (state.message != 'No plans found') {
      if (valid_start_time > current_time) {
        const formattedDate = moment.utc(valid_start_time).local().format('ll')
        const initialState = {
          message: $localize`Almost there! Your subscription will be activated on ${formattedDate}.`,
          showLink: false
        }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
                SelectRequestModalComponent,
                Object.assign({}, {class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState}),
            );
        }
        else {
            this.bsModalRef = this.modalService.show(
                SelectRequestModalComponent,
                Object.assign({}, {class: 'modal-dialog-centered select-survey-new', initialState}),
            );
        }
        const metaData = {
          "log": {
            "organisation_id": this.org_uid,
            "message": "Subscription not yet started"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)

      } else if (valid_start_time < current_time && valid_end_time < current_time) {
        const formattedDate = moment.utc(valid_end_time).local().format('ll')
        let initialState = {
          message: $localize`Unfortunately, your subscription expired on ${formattedDate}. `,
          showLink: this.canViewContactAccountManagerLink
        }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState }),
        );
        }
        else{
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new', initialState }),
        );
        }

        const metaData = {
          "log": {
            "organisation_id": this.org_uid,
            "message": "Subscription expired"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)
      } else if (valid_start_time < current_time && valid_end_time > current_time && (state.active == false || state.payment_status === 2)) {
        let initialState = {
            message: $localize`Unfortunately, your subscription is pending activation. `,
            showLink: this.canViewContactAccountManagerLink
          }
        if(this.requestTemplate){
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState }),
        );
        }
        else{
            this.bsModalRef = this.modalService.show(
          SelectRequestModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-survey-new', initialState }),
        );
        }

        const metaData = {
          "log": {
            "organisation_id": this.org_uid,
            "message": "Subscription not yet started"
          },
          "audit_log": "CLICK_REQUEST_FORBIDDEN"
        }
        this.planservice.postLog(metaData)
      } else {
        this.sendSurveymethod()
      }
    } else {
      let initialState = {
          message: $localize`Unfortunately, your subscription is pending activation. `,
          showLink: this.canViewContactAccountManagerLink
        }
      if(this.requestTemplate){
          this.bsModalRef = this.modalService.show(
        SelectRequestModalComponent,
        Object.assign({}, { class: 'modal-dialog-centered select-survey-new xxl-popup-product', initialState }),
      );
      }
      else {
          this.bsModalRef = this.modalService.show(
              SelectRequestModalComponent,
              Object.assign({}, {class: 'modal-dialog-centered select-survey-new', initialState}),
          );
      }
      const metaData = {
        "log": {
          "organisation_id": this.org_uid,
          "message": "Subscription unpaid or inactive"
        },
        "audit_log": "CLICK_REQUEST_FORBIDDEN"
      }
      this.planservice.postLog(metaData)
    }
  }

  openSelectReferenceModal() {
    if(this.requestTemplate){
        this.selectCheckTypeModal = this.modalService.show(
          SelectCheckTypeModalComponent,
          Object.assign({}, { class: 'modal-dialog modal-dialog-centered xxl-popup xxl-popup-product'}),
        );
        this.selectCheckTypeModal.content.closeBtnName = 'Close';

        this.selectCheckTypeModal.content.selectClick.pipe(take(1)).subscribe(res => {
            this.router.navigateByUrl('/request', { state: { checkType: res.data, template: res?.template, preFill: true } });
        });
    }
    else{
        this.selectCheckTypeModal = this.modalService.show(
          SelectCheckTypeModalComponent,
          Object.assign({}, { class: 'modal-dialog-centered select-reference-modal' }),
        );
        this.selectCheckTypeModal.content.closeBtnName = 'Close';

        this.selectCheckTypeModal.content.selectClick.subscribe(res => {
      this.router.navigateByUrl('/request', { state: { checkType: res.data, preFill: true } });
    });
    }
  }
}
